import axios from "axios";
import { useAuthValue } from "context/AuthContext";
import { useEffect, useMemo, useReducer, useRef, useState } from "react";
import useOffCanvasReducer from 'hooks/useOffCanvasReducer';
import { getUrlParam, removeUrlParameter } from 'utils/helpers';
import useUrlAction from "hooks/useUrlAction";
import useEventListener from "hooks/useEventListener";

const DEFAULT_FILTER = {
    'year': new Date().getFullYear(),
    'month': (new Date().getMonth() + 1)
}

export default function usePlan() {
    const [orders, setOrders] = useState();
    const [filter, setFilter] = useState(DEFAULT_FILTER);
    const { user } = useAuthValue();
    const [selectedAppointmentId, dispatchViewAppointment] = useOffCanvasReducer();
    const controllerRef = useRef(null);

    useUrlAction({
        show: [dispatchViewAppointment, [getUrlParam('id', true)]]
    });

    useEffect(() => {
        setOrders();
        if (controllerRef.current) {
            controllerRef.current.abort();
        }
        controllerRef.current = new AbortController();
        axios.get('/orders', {
            signal: controllerRef.current.signal,
            params: {
                extract_refunded: 1,
                organization_id: user?.agent?.getSelectedOrganization().id,
                ...(user.is_admin && { payment_method: 'CARD'} ),
                ...filter
            }
        })
        .then(res => setOrders(res.data))
        .catch(thrown => {
            console.log(thrown);
            if (axios.isCancel(thrown)) return;
            console.error(thrown.message);
        });

        return () => (controllerRef.current && controllerRef.current.abort());
    }, [filter]);

    const onDeleteAppointment = (appointment_id) => {
        dispatchViewAppointment('CLOSE');
        setOrders(
            orders.map(order => {
                if (!order.appointment_id || order.appointment_id !== appointment_id) return order;
                order.status = 'REFUNDED';
                return order;
            })
        );
    }

    const handleChangeFilter = (e) => {
        const { name, value } = e.target;
        setFilter({
            ...filter,
            [name]: value
        });
    }

    useEventListener({
        'appointment_deleted': (e) => onDeleteAppointment(e.detail.appointment.id),
    }, [orders]);
    

    return {
        orders,
        filter,
        selectedAppointmentId,
        dispatchViewAppointment,
        handleChangeFilter
    }
}